<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ 'billing.schedules.title' | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="creation-form">
      <button *ngIf="!isCreationMode" (click)="onEdit()" [matTooltip]="'billing.schedules.add' | translate" mat-mini-fab
        class="action-button" color="primary">
        <mat-icon aria-label="Add">add</mat-icon>
      </button>
      <app-schedule-edit *ngIf="isCreationMode && !editedId" (editFinished)="onEditFinished()">
      </app-schedule-edit>
    </section>

    <mat-form-field class="filterField">
      <mat-label>Filtrer</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Votre filtre" #input>
    </mat-form-field>

    <section class="datatable-schedules">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
        <ng-container matColumnDef="site">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'billing.schedules.list.site' | translate}} </th>
          <td mat-cell *matCellDef="let schedule"> {{ schedule.site.name }} </td>
        </ng-container>

        <ng-container matColumnDef="startDayTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'billing.schedules.list.startDayTime' | translate}}
          </th>
          <td mat-cell *matCellDef="let schedule"> {{ schedule.startDayTime }} </td>
        </ng-container>

        <ng-container matColumnDef="endDayTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'billing.schedules.list.endDayTime' | translate}}
          </th>
          <td mat-cell *matCellDef="let schedule"> {{ schedule.endDayTime }} </td>
        </ng-container>

        <ng-container matColumnDef="days">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'billing.schedules.list.days' | translate}} </th>
          <td mat-cell *matCellDef="let schedule">
            <ul class="ulDays">
              <li *ngFor="let day of schedule.days">{{ showDayText(day) | translate }} </li>
            </ul>
          </td>
        </ng-container>

        <ng-container matColumnDef="holidayGroup">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'billing.schedules.list.holidayGroup' | translate}}
          </th>
          <td mat-cell *matCellDef="let schedule"> {{ schedule.holidayGroup?.name }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> {{ 'billing.schedules.list.actions' | translate }} </th>
          <td mat-cell *matCellDef="let schedule">
            <ng-container *ngIf="schedule.id !== editedId">
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'billing.schedules.list.edit' | translate" (click)="onEdit(schedule.id)">
                <mat-icon aria-label="Edit">edit</mat-icon>
              </button>

              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'billing.schedules.list.delete' | translate" (click)="delete(schedule.id)">
                <mat-icon aria-label="Delete">delete</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let schedule" [attr.colspan]="displayedColumns.length">
            <div *ngIf="schedule.id === editedId" class="row-edit"
              [@detailExpand]="schedule.id === editedId ? 'expanded' : 'collapsed'">
              <app-schedule-edit [schedule]="schedule" (editFinished)="onEditFinished()"></app-schedule-edit>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row"
          [ngClass]="{ 'expanded-row': row.id === editedId }"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[20, 25, 50, 100]" showFirstLastButtons [length]="schedules.length"
        class="paginator"></mat-paginator>
    </section>
    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
  </mat-card-content>
</mat-card>